module.exports = __webpack_public_path__ + "img/25_30.84bcc171.png";